import React from "react";
import '../index.css';
import CanonicalTag from "./CanonicalTag";
import { Helmet } from "react-helmet";
import linestone from '../assets/Images/line-stone.jpg';
import clay from '../assets/Images/kaolin-clay.jpg';
import gypsum from '../assets/Images/gypsum.jpg';
import jawCrusher from '../assets/Images/jaw-crusher.jpg';
import cone from '../assets/Images/cone-crusher.jpg';
import hamer from '../assets/Images/hammer-crusher.jpg';
import impact from '../assets/Images/impact-crusher.jpg';

const CementRawMaterials = () => {
  return (
    <>
  {/* Helmet for title and description */}
      <Helmet>
         <title>Cement Raw Materials Supplier | Clinker, Gypsum & Fly Ash | Valerion Impex</title>
       
      <meta
    name="description"
    content="Valerion Impex supplies premium cement raw materials including clinker, gypsum, fly ash, limestone and slag for cement manufacturing and construction industries worldwide."
  />

  <meta
    name="keywords"
    content="cement raw materials, cement raw material supplier, clinker supplier, gypsum supplier, fly ash supplier, limestone supplier, slag supplier, cement manufacturing materials, OPC raw materials, PPC raw materials, industrial minerals, cement industry supplier, construction raw materials, bulk cement raw materials, Valerion Impex"
  />

      </Helmet>

      {/* Canonical URL */}
      <CanonicalTag url="https://www.cementmachineryparts.in/products/cement-raw-materials" />
    <div>
      <h1 className="cement-raw bg-dark text-white text-center mt-3 py-2 mx-auto mb-3">
        Raw Materials and Equipments</h1>
      <div className="container raw-material mb-3">
        <h3 className="text-center text-primary fs-1">Raw Materials</h3>
        <div className="row">
          <div className="col-md-6 order-6">
            <img src={linestone} className="img-fluid rawmaterial mx-auto" alt="Limestone" />
          </div>

          <div className="col-md-6 rawmaterial-text mb-2 mt-2 order-6">
            <p><b>Limestone: </b> Common forms of calcium carbonate used as raw material for cement manufacturing are limestone and chalk.Limestone is of predominantly fine-grained crystalline structure; its hardness is between 1.8 to 3.0 of the Mohs scale of hardness and specific gravity 2. To 2.8. Limestone usually contains admixtures of clay substance or iron compounds, which influences its color. Only the purest varieties of limestone are white.</p>
          </div>

          <div className="col-md-6 rawmaterial-text mt-2 mb-2 order-5">
            <p> <b>Clay:</b> The second important raw material for cement production is Clay. The main component of clay is formed by hydrous aluminum silicates. The chemical composition of clay may vary from those close to the pure clay, to that containing a significant amount of admixtures as iron hydroxide, iron sulfide, sand, calcium carbonate, etc. Clay is used as an argillaceous component of raw mix.</p>
          </div>
          <div className="col-md-6 order-4">
            <img src={clay} className="img-fluid mx-auto rawmaterial " alt="Clay" />
          </div>

          <div className="col-md-6 order-3">
            <img src={gypsum} className="img-fluid mx-auto rawmaterial mt-2 mb-2" alt="Gypsum" />
          </div>
          <div className="col-md-6 rawmaterial-text mt-2 mb-3 order-3">
            <p><b>Gypsum :</b>  is the raw material commonly used in construction, building

              materials, chemical industry, metallurgy, coating, and other industrial fields
              Gypsum plays a very important role in controlling the rate of hardening of the
              cement.  Gypsum (hydrated calcium sulphate caso4.2h2o) 85 to 95 %
              chemical-phosphor gypsum natural gypsum for agriculture and industrial use</p>
          </div>
        </div>
      </div>

      {/* ------------------CRUSHERS------------- */}
      <div className="container">
        <h3 className="cementraw bg-dark text-white  mt-3 py-2 mx-auto mb-3">
          We  are always committed to deliver the best quality items to our customer at industry leading prices</h3>
        <h4 className="text-center text-primary fs-1"><b> CRUSHERS</b></h4>
        <div className="row">
          <div className="col-lg-6 mx-auto px-5 ">
            <img src={jawCrusher} className="img-fluid crusher" alt="Jaw Crusher" />
          </div>
          <div className="col-lg-6 ">
            <p className="mt-2 fs-4"><b>Jaw Crushers</b></p>
            <p><b>Production Capacity : </b> 1-200t/h</p>
            <p><b>Feeding Size: </b> 125-1200mm</p>
            <p><b>Application:</b> Pebble, calcite, granite, quartz,
              Concrete, dolomite, bluestone, Iron ore ,
              Limestone construction waste .</p>
            <p>The jaw crusher is suitable for crushing various ores or rocks with a compressive strength limit below 250 MPa. Widely apply for mining, cement and concrete industries. It is mainly used as coarse crusher and medium crusher in mines, building materials and infrastructure. The jaw cement crusher produced by Tuff brand has the characteristics of simple structure, easy manufacture, reliable operation, long service life and convenient maintenance</p>
          </div>
        </div>

        <div className="row align-items-center mt-4 mb-5 flex-lg-row-reverse">
          <div className="col-lg-6 mb-3">
            <img src={cone} className="img-fluid crusher rounded" alt="corn" />
          </div>
          <div className="col-lg-6 cone-text">
            <p className="mt-3 fs-4"><b>Cone Crusher </b></p>
            <span><b>Production Capacity :</b> 12-1, 814mᵌ/H</span><br />
            <span><b>Feeding Size:</b> ≤350mm</span><br />
            <span><b>Application:</b> Cobble granite , Basalt, iron
              Ore, Limestone, quartz stone , diabase , gold
              Ore and copper ore.</span> <br />
            <p>Raw materials of the cement plant are mostly from open-pit mines, and the ore size of large mines can reach 1.5-1.8m. In the preparation of cement raw materials, we first need to crush limestone, gypsum, clay and other materials into proper size to facilitate the subsequent transportation and storage, at the same time make full preparations for the next process (cement raw materials grinding). Therefore, as the first process of cement production, material crushing is particularly important in the design of a cement plant.</p>
          </div>
        </div>

        <div className="row">
          <div className="col-lg-6 px-5 mb-3">
            <img src={hamer} className="img-fluid crusher rounded" alt="hamer" />

          </div>
          <div className="col-lg-6">
            <p className="mt-3 fs-4"><b>Hammer Crusher</b></p>
            <p><b>Production Capacity :</b>5-600m³/h</p>
            <p><b>Feeding Size :</b>≤314mm</p>
            <p><b>Application :</b>Coal, Salt, Gypsum,
              alums, Brick, Tile, Limestone</p>
            <p>Raw materials of the cement plant are mostly from open-pit mines, and the ore size of large mines can reach 1.5-1.8m. In the preparation of cement raw materials, we first need to crush limestone, gypsum, clay and other materials into proper size to facilitate the subsequent transportation and storage, at the same time make full preparations for the next process (cement raw materials grinding). Therefore, as the first process of cement production, material crushing is particularly important in the design of a cement plant.</p>
          </div>


          <div className="row align-items-center mt-2 mb-2 flex-lg-row-reverse">
            <div className="col-lg-6 mt-3">
              <img src={impact} alt="impac" className="img-fluid crusher rounded" />

            </div>

            <div className="col-lg-6 mb-2 mt-2">
              <p className="mt-5 fs-4"><b>Impact Crusher </b></p>
              <p><b>Production Capacity :</b>30-550t/h</p>
              <p><b>Feeding Size: </b>300-700mm</p>
              <p><b>Application:</b> river gravel, granite, basalt,
                iron ore, limestone, quartz stone, coal gangue,
                dolomite, feldspar, calcite, talc, barite
                and building wastes, etc.</p>
              <p>The impact crusher is a new and high-efficient cement crusher, with advantages of small size, simple structure, and large reduction ratio, less energy consumption, uniform practical size and flexible selectivity. The remarkable features of impact crusher is large feeding mouth, impact crusher own 1.5 times or even 2 times larger crushing cavity than that of other crushers.</p>
            </div>
          </div>

        </div>
      </div>
    </div>
</>
  );
};

export default CementRawMaterials;
